export default {
    name:'management',
    data: function() {
      return {
        total: '100',
        patientName:'',
        dateOfSurgery: '',
        keywordSearch: '',
        columns4: [
          {
            title: this.$t('Software'),
            key: 'software'
          },{
            title: this.$t('Expiration Date'),
            slot: 'expirationdate'
          },{
            title: ' ',
            width: 100,
            slot: 'action'
          }
        ],
        data4: [
          {
            software: 'ImmersiveView',
            expirationdate: '03/16/2020'
          },{
            software: 'IVSP',
            expirationdate: '03/16/2020'
          },{
            software: 'ImmersiveTouch',
            expirationdate: '03/16/2020'
          },{
            software: 'ImmersiveTouch',
            expirationdate: '03/16/2020'
          }
        ],
        columns1: [
          {
            title: this.$t('name'),
            key: 'name'
          },{
            title: this.$t('email'),
            key: 'email'
          },{
            title: this.$t('phone number'),
            key: 'phonenumber'
          },{
            title: this.$t('admin'),
            slot: 'admin'
          }
        ],
        data1: [
          {
            name: 'Anne Lee',
            email: 'David5789@yahoo.com',
            phonenumber: '18756523691'
          },{
            name: 'Anne Lee',
            email: 'David5789@yahoo.com',
            phonenumber: '18756523691'
          }
        ],
        modal: false,
        modal1: false,
        modal2: false,
        modal3: false,
        modal4: false,
        modal5: false,
        modal6: false,
        modal7: false,
        modal8: false,
        modal9: false,
        modal10: false,
        txtComment: '',
        formItem: {
            physician: '',
            specialty: '',
            patientname: '',
            hospital: '',
            dateofsurgery: '',
            priority: false
        },
        note:'',
        ruleInline: {
            patientname: [
                { required: true, message: this.$t('Please fill in the patient name'), trigger: 'blur' }
            ],
            hospital: [
                { required: true, message: this.$t('Please select the hospital'), trigger: 'change' }
            ],
            priority:[
                { required: true, message: this.$t('Please select at priority'), trigger: 'change', type: 'boolean' }
            ]
        },
        modalNext: false,
        fileList: [],
        showTable: '',
        columns2: [
            {
              title: this.$t('physician'),
              key: 'physician'
            },{
              title: this.$t('specialty'),
              key: 'address'
            },{
                title: this.$t('email'),
                key: 'email',
                width:250
            },{
                title: this.$t('phone number'),
                key: 'phonenumber'
            },{
              title: this.$t('hospital'),
              minWidth: 100,
              key: 'hospital'
            },{
              title: this.$t('total customcases'),
              key: 'totalCustomCases'
            },{
              title: this.$t('total automatic cases'),
              key: 'totalAutomaticCases'
            },{
              title: this.$t('admin'),
              slot: 'admin'
            }
          ],
        data2: [
          {
            email: 'David5789@yahoo.com',
            phonenumber: '18756523691',
            physician: 'Adam Davis',
            address: 'Surgery',
            totalCustomCases: 20,
            totalAutomaticCases: 43,
            hospital: 'University of ChicagoHospital',
            dateofsurgery: '03/02/2019',
            priority: 1,
            status: 'Loaded'
          },{
              email: 'David5789@yahoo.com',
              phonenumber: '18756523691',
              physician: 'Adam Davis',
              address: 'Surgery',
              totalCustomCases: 20,
              totalAutomaticCases: 43,
              hospital: 'University of ChicagoHospital',
              dateofsurgery: '03/02/2019',
              priority: 1,
              status: 'Loaded'
          }
        ],
        modalName:'',
        modalPhone:'',
        oldEmailLogin:'',
        newEmailLogin:'',
        software:'',
        expirationDate:'',
        newName:'',
        newEmail:'',
        role:'',
        surgery:'',
        pagesize:20,
        pageTo:"1",
        row:{},
        myName:'Mira Liu',
        myCompany:'Orthopedics', 
        hospitalInputList:[
          {hospitalName:''}
        ]  
      }
    },
    methods: {
      delHospital(index){
        this.hospitalInputList.splice(index,1)
      },
      addHospital(){
        let obj={
          hospitalName:''
        }
        this.hospitalInputList.push(obj)
        // let arr = hospitalInputList
        // arr.push(obj)
        // this.hospitalInputList = arr
      },
      changePageSize(size){
        this.pagesize = size
      },
      sel(row,e){
        console.log(row)
        this.row = row
        console.log(e)
        if(e === 'edit'){
          if(this.showTable === 'sales-representative'){
            this.modal1 = true
          }else{
            this.modal8 = true
          }
        }else if(e === 'change'){
          this.modal2 = true
        }else if(e === 'manage'){
          this.modal4 = true
        }else{
          this.modal9 = true
        }
      },
      inviteUser(){
        if(this.showTable === 'sales-representative'){
          this.modal7 = true
        }else{
          this.modal6 = true
        }
      },
      ok10(){
        this.modal10 = false
      },
      ok9(){
        this.modal9 = false
      },
      cancel9(){
        this.modal9 = false
      },
      ok8(){
        this.modal8 = false
      },
      cancel8(){
        this.modal8 = false
      },
      ok7(){
        this.modal10 = true
        this.modal7 = false
      },
      cancel7(){
        this.modal7 = false
      },
      ok6(){
        this.modal10 = true
        this.modal6 = false
      },
      cancel6(){
        this.modal6 = false
      },
      dateChange(e){
        this.expirationDate = e
      },
      addLicenses(){
        this.modal5 = true
      },
      ok5(){
        this.modal5 = false
      },
      cancel5(){
        this.modal5 = false
      },
      ok4(){
        this.modal4 = false
      },
      cancel4(){
        this.modal4 = false
      },
      ok3(){
        this.modal3 = false
      },
      ok2(){
        this.modal3 = true
        this.modal2 = false
      },
      cancel2(){
        this.modal2 = false
      },
      ok1(){
        this.modal3 = true
        this.modal1 = false
      },
      cancel1(){
        this.modal1 = false
      },
        fileAdded(file){
            console.log(file,1)
        },
        delFile(i){
            this.fileList.splice(i,1)
        },
        handleUpload(file){
            console.log(file)
            let arr = this.fileList;
            arr.push(file)
            this.fileList = arr
            
            return false;
        },
        back(){
            this.modalNext = false
        },
        handleSubmit (name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.$Message.success('Success!');
                    this.modalNext = true
                } else {
                    this.$Message.error('Fail!');
                }
            })
        },
        ok(){
            this.modal = false
            this.modalNext = false
            this.formItem.physician = ''
            this.formItem.specialty = ''
            this.formItem.patientname = ''
            this.formItem.hospital = ''
            this.formItem.dateofsurgery = ''
            this.formItem.priority = false
        },
        cancel () {
            this.modal = false
            this.formItem.physician = ''
            this.formItem.specialty = ''
            this.formItem.patientname = ''
            this.formItem.hospital = ''
            this.formItem.dateofsurgery = ''
            this.formItem.priority = false
        },
      addCase(){
        this.modal = true
      },
      download(row,index){
        console.log(row)
        console.log(index)
      },
      showDate(){
        console.log(this.dateOfSurgery)
      },
      navClick(type){
          this.showTable = type
          sessionStorage.setItem('showTable',type)
      }
    },
    destroyed(){
        sessionStorage.removeItem('showTable')
    },
    created(){
  
    },
    mounted(){
        this.showTable = sessionStorage.getItem('showTable') || 'physician'
    }
  }